export default {
	orange: '#FB8C00',
	green: '#43A047',
	red: '#e53935',
	white: '#fff'
}